// extracted by mini-css-extract-plugin
module.exports = {"component":"statistic_component_3cuHX","bar":"statistic_bar_1gO7o","fill":"statistic_fill_2ZA4m","label":"statistic_label_35Yw_"};